
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.443 7.333l-1.443 2-1.443-2h2.886z","fill":"#2A333D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.574 3.34a4.667 4.667 0 01-.24 9.327H4.666a4.667 4.667 0 01-.24-9.328l.24-.006h6.666l.24.006zM4.667 4.666a3.333 3.333 0 100 6.667h6.666a3.333 3.333 0 100-6.667H4.667z","fill":"#2A333D"}})])
          )
        }
      }
    